import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from 'seagull';
import { Clock } from 'seagull/icons';
import { formatDateTimeWithShortMonth } from '~/utils/date-formatting';
export const ScheduledTooltip = (param)=>{
    let { index, scheduleDate } = param;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(Tooltip, {
            placement: "right",
            testId: "scheduled-tooltip-".concat(index),
            title: "This proposal is scheduled to be sent on ".concat(formatDateTimeWithShortMonth(new Date(scheduleDate))),
            children: /*#__PURE__*/ _jsx("div", {
                "data-testid": "scheduled-tooltip-icon-".concat(index),
                children: /*#__PURE__*/ _jsx(Clock, {
                    size: 16
                })
            })
        })
    });
};
